import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function SubscriptionPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    navigate(`/billing${location.search}`, {
      replace: true,
      state: { tab: "plans" },
    });
  }, [navigate, location.search]);

  return null;
}
